import { Box } from "@mui/material";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";

interface LoadingSpinnerProps {
  loading: boolean;
  color?: string;
  sx?: object;
  size?: number | string;
}

const LoadingSpinner = (props: LoadingSpinnerProps) => {
  const { loading, color, sx, size = 26 } = props;

  if (!loading) {
    return null;
  }

  return (
    <Box
      justifyContent="center"
      sx={{ display: "flex", top: "50%", left: "50%", ...sx }}
    >
      <CircularProgress size={size} sx={{ color: color }} />
    </Box>
  );
};

LoadingSpinner.propTypes = {
  loading: PropTypes.bool,
  color: PropTypes.string,
  sx: PropTypes.object,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default LoadingSpinner;
